import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import subProductInfoList from './subProductInfoList.vue';

formCreate.component('subProductInfoList', subProductInfoList);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      // rule: [],
      formFunctionCode: 'add_form',
    };
  },
  methods: {

    // 设置规则
    setRule(item) {
      if (item.field === 'imageList') {
        item.props = {
          ...item.props,
          limit: 1,
        };
      }
      if (item.field === 'carouselPicture') {
        item.props = {
          ...item.props,
          limit: 10,
        };
      }
      if (item.field === 'productType') {
        item.on = {
          ...item.on,
          change: (e) => {
            console.log(e);
            // if (e === '3') {
            //   this.hiddenFields(false, ['amount', 'rewardPoint']);
            // } else {
            //   this.hiddenFields(true, ['amount', 'rewardPoint']);
            // }
            this.setValue({
              subProductInfoList: [],
            });
          },
        };
      }
      if (item.field === 'subProductInfoList') {
        item.props = {
          ...item.props,
          getValue: (field) => this.getFieldValue(field),
        };
      }
      // if (item.field === 'amount') {
      //   item.validate = [
      //     ...item.validate,
      //     {
      //       trigger: 'blur',
      //       pattern: '^(?:[1-9][0-9]*(?:[.][0-9]+)?|0?[.][0-9]*[1-9][0-9]*)$',
      //       message: '仅能输入大于0的数',
      //     },
      //   ];
      // }
      // if (item.field === 'rewardPoint') {
      //   item.validate = [
      //     ...item.validate,
      //     {
      //       trigger: 'blur',
      //       pattern: '^[1-9][0-9]*$',
      //       message: '仅能输入正整数',
      //     },
      //   ];
      // }
      return item;
    },

    handleProductSourceChange(e) {
      if (e === '1') {
        this.hiddenFields(false, ['productName']);
        this.hiddenFields(true, ['productName1']);
        const productName = this.getRule('productName');
        this.disabled(true, ['productCode', 'specification', 'productHierarchy']);
      } else {
        this.hiddenFields(true, ['productName']);
        this.hiddenFields(false, ['productName1']);
        this.disabled(false, ['productCode', 'specification', 'productHierarchy']);
      }
    },
    // 渲染完成后执行
    formComplete() {
      this.hiddenFields(true, ['productName1', 'amount', 'rewardPoint']);
      const { code, row } = this.formConfig;
      if (code === 'edit' || code === 'view') {
        request.get('/cps/v1/memberIntegralProductInfo/memberIntegralProductInfo/findById', { id: row.id }).then((res) => {
          if (res.success) {
            const { result } = res;
            let urlType1 = '';
            const urlType2 = [];
            const urlType3 = [];
            result.imageList.forEach((val) => {
              if (val.urlType === '1') {
                urlType1 = val.urlPath;
              }
              if (val.urlType === '2') {
                urlType2.push(val.urlPath);
              }
              // if (val.urlType === '3') {
              //   urlType3.push(val.urlPath);
              // }
            });
            const subProductInfoListRe = this.getRule('subProductInfoList');
            subProductInfoListRe.props.productTypeFlag = result.productType;
            // if (result.productType === '3') {
            //   this.hiddenFields(false, ['amount', 'rewardPoint']);
            // } else {
            //   this.hiddenFields(true, ['amount', 'rewardPoint']);
            // }
            // this.handleProductSourceChange(result.productSource);
            this.setValue({
              ...result,
              urlType1,
              urlType2,
            });
          }
        });
      }
    },
    // 提交
    submit() {
      let formData = this.getFormData(); // 获取表单的值
      console.log('tjiao', formData);
      const regOne = /^[1-9][0-9]*$/;
      const regTwo = /^(?:[1-9][0-9]*(?:[.][0-9]+)?|0?[.][0-9]*[1-9][0-9]*)$/;
      const productName = this.getRule('productName');
      if (formData) {
        if (formData.subProductInfoList && formData.subProductInfoList.length > 0) {
          for (let i = 0; i < formData.subProductInfoList.length; i += 1) {
            if (!formData.subProductInfoList[i].productSource) {
              this.$message.error('产品来源不能为空!');
              return false;
            }
            if (!formData.subProductInfoList[i].productName) {
              this.$message.error('产品名称不能为空!');
              return false;
            }
            if (!formData.subProductInfoList[i].productCode) {
              this.$message.error('产品编码不能为空!');
              return false;
            }
            if (!formData.subProductInfoList[i].specification) {
              this.$message.error('产品规格不能为空!');
              return false;
            }
            if (!formData.subProductInfoList[i].displayType) {
              this.$message.error('商品分类不能为空!');
              return false;
            }
            if (!formData.subProductInfoList[i].productHierarchy) {
              this.$message.error('商品层级不能为空!');
              return false;
            }
            if (!formData.subProductInfoList[i].startTime) {
              this.$message.error('开始时间不能为空!');
              return false;
            }
            if (!formData.subProductInfoList[i].endTime) {
              this.$message.error('结束时间不能为空!');
              return false;
            }
            if (!formData.subProductInfoList[i].unit) {
              this.$message.error('兑换单位不能为空!');
              return false;
            }
            if (formData.productType === '1') {
              if (!formData.subProductInfoList[i].integral) {
                this.$message.error('商品兑换积分不能为空!');
                return false;
              }
              if (!regOne.test(formData.subProductInfoList[i].integral)) {
                this.$message.error('商品兑换积分仅能输入正整数!');
                return false;
              }
            }
            if (formData.productType === '3') {
              if (!formData.subProductInfoList[i].rewardPoint) {
                this.$message.error('现金下单奖励积分不能为空!');
                return false;
              }
              if (!regOne.test(formData.subProductInfoList[i].rewardPoint)) {
                this.$message.error('现金下单奖励积分仅能输入正整数!');
                return false;
              }

              if (!formData.subProductInfoList[i].price) {
                this.$message.error('商品原价不能为空!');
                return false;
              }
              if (!regTwo.test(formData.subProductInfoList[i].rewardPoint)) {
                this.$message.error('商品原价仅能输入大于0的数!');
                return false;
              }

              if (!formData.subProductInfoList[i].memberPrice) {
                this.$message.error('商品会员价不能为空!');
                return false;
              }
              if (!regTwo.test(formData.subProductInfoList[i].rewardPoint)) {
                this.$message.error('商品会员价仅能输入大于0的数!');
                return false;
              }
            }
            if (!formData.subProductInfoList[i].imageList.length) {
              this.$message.error('商品列表图不能为空!');
              return false;
            }
            if (!formData.subProductInfoList[i].detailedPicture.length) {
              this.$message.error('商品详情图不能为空!');
              return false;
            }
          }
        }
        // const arr = productName.options.filter((val) => val.value === formData.productName);
        const imgArr = [];
        // const detailedArr = [];
        const carouselArr = [];
        if (formData.urlType1) {
          formData.urlType1.forEach((val) => {
            imgArr.push({
              urlPath: val,
              urlType: 1,
            });
          });
        }
        if (formData.urlType2) {
          formData.urlType2.forEach((val) => {
            carouselArr.push({
              urlPath: val,
              urlType: 2,
            });
          });
        }
        formData = {
          ...formData,
          imageList: imgArr,
          carouselPicture: carouselArr,
          // detailedPicture: detailedArr,

          // productName: formData.productSource === '1' ? formData.productName : formData.productName1,
        };
        // 默认新增
        let url = '/cps/v1/memberIntegralProductInfo/memberIntegralProductInfo';
        // 有id  就是编辑
        if (this.formConfig.row.id) {
          formData.id = this.formConfig.row.id;
          formData.productIntegralCode = this.formConfig.row.productIntegralCode;
          url = '/cps/v1/memberIntegralProductInfo/memberIntegralProductInfo/update';
        }
        request.post(url, formData).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
